import { loadPlaces } from '@services/places';

const apiKey = import.meta.env.VITE_GOOGLE_PLACES_API_KEY;

/**
 * Resolve a free-text location (e.g. shop name + address + postcode) to
 * `{ lat, lng }` via the Google Places Text Search API.
 *
 * The shop's stored `geolocation` and `googlePlaceId` are NOT reliable: a shop
 * created/migrated without the real Google Place applied keeps the registration
 * default placeId (`ChIJ4Rbz-ascdkgRdhUalPZ2UFI` — "Mart's Beauty Store",
 * London), and `geolocation` is derived from it, so both point at London
 * (NEA-5848). The shop's `address`/`postcode`/`city` are reliable, so we geocode
 * those instead. (Google's Geocoding API isn't enabled on our key and the
 * Mapbox token is scoped to tiles only — Places Text Search is the geocoder we
 * have.)
 *
 * Returns null when the query is empty, the key is missing, or no match is found
 * — callers should fall back to the stored geolocation.
 */
export async function geocodeQuery(query) {
	if (!query || !query.trim() || !apiKey) return null;
	const { Place } = await loadPlaces(apiKey);
	const { places } = await Place.searchByText({ textQuery: query, fields: ['location'] });
	const location = places?.[0]?.location;
	if (!location) return null;
	return { lat: location.lat(), lng: location.lng() };
}
